import React from 'react';
import { Drawer as AntdDrawer } from 'antd';
import styles from './Sidebar.module.scss';
import { IoCloseOutline } from 'react-icons/io5';
import { CrossIcon } from '../all-icons/custom-icons';
import { isSmallScreen } from '../../utils';

const Sidebar = ({
  setSidebarOpen = () => {},
  sidebarOpen = false,
  placement = 'right',
  content = '',
  title = true,
  closeIcon = false,
  heading = '',
  description = '',
  sidebarWidth = 450,
  footer,
  loading = false,
  onCloseSidebar = () => {},
  destroyOnClose = true,
  crossStyle = {},
  ...rest
}) => {
  const onClose = () => {
    setSidebarOpen(false);
    onCloseSidebar && onCloseSidebar();
  };

  return (
    <div className={styles.customSidebar}>
      <AntdDrawer
        placement={placement}
        width={isSmallScreen() ? '95vw' : sidebarWidth}
        open={sidebarOpen}
        loading={loading}
        onClose={onClose}
        destroyOnClose={destroyOnClose}
        footer={footer}
        className={''}
        title={
          title && (
            <>
              {heading && <div className={styles.sidebarHeading}>{heading}</div>}
              {description && <div className={styles.sidebarDesc}>{description}</div>}
            </>
          )
        }
        extra={
          <CrossIcon
            size={26}
            style={{ cursor: 'pointer', color: 'var(--text-main)', ...crossStyle }}
            onClick={onClose}
          />
        }
        closeIcon={closeIcon}
        {...rest}
      >
        {content}
      </AntdDrawer>
    </div>
  );
};

export default Sidebar;
